module.exports = __webpack_public_path__ + "img/why1.2b765980.svg";